import { Component, OnInit, ElementRef, Inject, OnDestroy, ChangeDetectorRef } from '@angular/core';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl, EmailValidator } from '@angular/forms';

import { roleMasterMenuname } from '../../../enums/roleMasterMenuName';

import { PermissionLinks } from '../../../enums/permissionLinks';

import { roleMasterIconClass } from '../../../enums/roleMasterMenuName';

import { RoleMasterService } from '../../../services/rolemaster.service';
import * as _ from 'lodash';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../../services/loader.service';

interface RoleMenuGroup {
  key: string;
  label: string;
  menuList: any[];
  prefix?: string;
  flat?: boolean;
}

@Component({
  selector: 'app-add-role-modal',
  templateUrl: './add-role-modal.component.html',
  styleUrls: ['./add-role-modal.component.css'],
})
export class AddRoleModalComponent implements OnInit, OnDestroy {


  loggedInUserInfo: any;
  isGuestSuperAdmin: boolean;

  addRoleForm: FormGroup;
  public menuName: string;
  masterMenu: any = [];
  boardEvaluationMenu: any = [];
  riskEvaluationMenu: any = [];
  upsiMenu: any = [];
  ncdMenu: any = [];
  governanceMenu: any = [];
  complianceMenu: any = [];
  documentManagementMenu: any = [];
  lawAndRegulationMenu: any = [];
  adminMenu: any = [];
  dashboardMenu: any = [];
  gemMenu: any = [];
  addedRoles: any = [];
  finalRoleList: any = [];
  /** Primary selection state — drives all checkbox and icon UI */
  private selectedUrls = new Set<string>();
  /** Maps child resource Url -> MenuDisplayName key for submit/chips */
  private urlMenuKeyMap = new Map<string, string>();
  isfinalRoleListEmpty: boolean = true;
  roleNamePatternRegEx: any = "^[a-zA-Z][a-zA-Z\-\_\/ ]*$";
  checkboxClickSelected: boolean;


  isPSSConfig = environment.Service.PSS;
  isGovevaConfig = environment.Service.GovEva;
  isUPSIConfig = environment.Service.UPSI && environment.FinalMenu.UPSI;;
  isAllConfig = environment.Service.All;
  isNCDConfig = environment.Service.NCD && environment.FinalMenu.NCD;;
  isGEMConfig = environment.Service.GEM;
  isLawsConfig = environment.FinalMenu.Laws;
  // isGovernance = environment.Service.Governance;
  isMeetingMakerWithoutAgenda = environment.Service.MeetingMakerWithoutAgenda;
  isMeetingMakerWithAgenda = environment.Service.MeetingMakerWithAgenda;

  isBoardEvaluationConfig = environment.Service.BoardEvaluation;
  isRiskEvaluationConfig = environment.Service.RiskEvaluation;

  menuGroups: RoleMenuGroup[] = [];
  activeMenuKey = 'master';
  permissionSearch = '';

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private roleMasterService: RoleMasterService, private elementRef: ElementRef, @Inject(DOCUMENT) document, private loaderService: LoaderService, private cdr: ChangeDetectorRef) {
    this.addRoleForm = this.fb.group({
      roleName: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern(this.roleNamePatternRegEx)])
    })

  }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  isIconSelected(url: string): boolean {
    return !!url && this.selectedUrls.has(url);
  }

  private getMenuChildUrls(menu: any): string[] {
    if (!menu) {
      return [];
    }
    let urls: string[];
    if (!menu.ChildResources) {
      urls = menu.Url ? [menu.Url] : [];
    } else {
      urls = menu.ChildResources.map((child: any) => child.Url).filter(Boolean);
    }
    return Array.from(new Set(urls));
  }

  private getMenuDisplayKey(menu: any, prefix = ''): string {
    if (menu.MenuDisplayName === undefined) {
      return prefix + menu.DisplayName;
    }
    return prefix ? prefix + menu.MenuDisplayName : menu.MenuDisplayName;
  }

  private countSelectedForMenu(menu: any): number {
    return this.getMenuChildUrls(menu).filter(url => this.selectedUrls.has(url)).length;
  }

  private totalForMenu(menu: any): number {
    return this.getMenuChildUrls(menu).length;
  }

  isMenuRowChecked(menu: any): boolean {
    const total = this.totalForMenu(menu);
    return total > 0 && this.countSelectedForMenu(menu) === total;
  }

  isMenuRowIndeterminate(menu: any): boolean {
    const selected = this.countSelectedForMenu(menu);
    const total = this.totalForMenu(menu);
    return selected > 0 && selected < total;
  }

  private getSelectableMenus(menuList: any[]): any[] {
    return menuList.filter(
      menu => menu.MenuDisplayName !== 'UPSI Detail All' && this.totalForMenu(menu) > 0
    );
  }

  private getAllSelectableUrls(menuList: any[]): string[] {
    return this.getSelectableMenus(menuList).flatMap(menu => this.getMenuChildUrls(menu));
  }

  isSelectAllChecked(menuList: any[]): boolean {
    const urls = this.getAllSelectableUrls(menuList);
    return urls.length > 0 && urls.every(url => this.selectedUrls.has(url));
  }

  isSelectAllIndeterminate(menuList: any[]): boolean {
    const urls = this.getAllSelectableUrls(menuList);
    if (!urls.length || this.isSelectAllChecked(menuList)) {
      return false;
    }
    const selectedCount = urls.filter(url => this.selectedUrls.has(url)).length;
    return selectedCount > 0;
  }

  /** Rebuild derived arrays from selectedUrls so Angular detects changes */
  private syncSelectionState(): void {
    this.finalRoleList = Array.from(this.selectedUrls).map(url => ({
      MenuDisplayName: this.urlMenuKeyMap.get(url) || url,
      childUrl: url,
    }));

    const menuKeys = new Map<string, string>();
    this.finalRoleList.forEach(entry => {
      if (!menuKeys.has(entry.MenuDisplayName)) {
        menuKeys.set(entry.MenuDisplayName, entry.childUrl);
      }
    });
    this.addedRoles = Array.from(menuKeys.entries()).map(([MenuDisplayName, id]) => ({
      MenuDisplayName,
      id,
    }));

    this.isfinalRoleListEmpty = this.selectedUrls.size === 0;
    this.cdr.detectChanges();
  }

  private selectUrls(urls: string[], menuDisplayName: string): void {
    urls.forEach(url => {
      this.selectedUrls.add(url);
      this.urlMenuKeyMap.set(url, menuDisplayName);
    });
    this.syncSelectionState();
  }

  private deselectUrls(urls: string[]): void {
    urls.forEach(url => {
      this.selectedUrls.delete(url);
      this.urlMenuKeyMap.delete(url);
    });
    this.syncSelectionState();
  }

  private deselectAllForMenu(menu: any): void {
    this.deselectUrls(this.getMenuChildUrls(menu));
  }

  private selectAllForMenu(menu: any, menuDisplayName: string, skipUpsiDetailAll = false): void {
    if (skipUpsiDetailAll && menu.MenuDisplayName === 'UPSI Detail All') {
      return;
    }
    this.selectUrls(this.getMenuChildUrls(menu), menuDisplayName);
  }

  private clearMenuSelectionByDisplayName(menuList: any[], displayName: string): void {
    const menu = menuList.find((item: any) => item.MenuDisplayName === displayName);
    if (menu) {
      this.deselectAllForMenu(menu);
    }
  }

  onSelectAllChange(event: Event, group: RoleMenuGroup): void {
    const checked = (event.target as HTMLInputElement).checked;
    const prefix = group.prefix || '';

    if (checked) {
      this.getSelectableMenus(group.menuList).forEach(menu => {
        const menuDisplayName = this.getMenuDisplayKey(menu, prefix);
        this.getMenuChildUrls(menu).forEach(url => {
          this.selectedUrls.add(url);
          this.urlMenuKeyMap.set(url, menuDisplayName);
        });
      });
    } else {
      group.menuList.forEach(menu => {
        this.getMenuChildUrls(menu).forEach(url => {
          this.selectedUrls.delete(url);
          this.urlMenuKeyMap.delete(url);
        });
      });
    }

    this.syncSelectionState();
  }

  onMenuRowChange(event: Event, menu: any, menuDisplayName: string, menuList: any[]): void {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      if (this.isUPSIConfig && menuDisplayName === 'UPSI Detail Individual') {
        this.clearMenuSelectionByDisplayName(menuList, 'UPSI Detail All');
      } else if (this.isUPSIConfig && menuDisplayName === 'UPSI Detail All') {
        this.clearMenuSelectionByDisplayName(menuList, 'UPSI Detail Individual');
      }
      this.getMenuChildUrls(menu).forEach(url => {
        this.selectedUrls.add(url);
        this.urlMenuKeyMap.set(url, menuDisplayName);
      });
    } else {
      this.getMenuChildUrls(menu).forEach(url => {
        this.selectedUrls.delete(url);
        this.urlMenuKeyMap.delete(url);
      });
    }

    this.syncSelectionState();
  }

  setActiveMenu(key: string): void {
    this.activeMenuKey = key;
    this.permissionSearch = '';
  }

  get activeGroup(): RoleMenuGroup | undefined {
    return this.menuGroups.find(group => group.key === this.activeMenuKey);
  }

  getMenuLabel(menu: any, group: RoleMenuGroup): string {
    if (group.flat) {
      return menu.DisplayName || menu.MenuDisplayName || '';
    }
    return menu.MenuDisplayName || menu.DisplayName || '';
  }

  getMenuDisplayName(menu: any, group: RoleMenuGroup): string {
    return this.getMenuDisplayKey(menu, group.prefix || '');
  }

  getMenuActions(menu: any, group: RoleMenuGroup): any[] {
    if (group.flat || !menu.ChildResources) {
      return menu.Url ? [menu] : [];
    }
    return menu.ChildResources || [];
  }

  getFilteredMenus(group: RoleMenuGroup): any[] {
    const query = (this.permissionSearch || '').trim().toLowerCase();
    if (!query) {
      return group.menuList;
    }
    return group.menuList.filter(menu => this.getMenuLabel(menu, group).toLowerCase().includes(query));
  }

  getGroupSelectedCount(group: RoleMenuGroup): number {
    return this.getAllSelectableUrls(group.menuList).filter(url => this.selectedUrls.has(url)).length;
  }

  getIconClass(iconName: string): string {
    const map: Record<string, string> = {
      view: 'fa-eye',
      edit: 'fa-pencil',
      add: 'fa-plus-circle',
      delete: 'fa-trash-o',
      authorize: 'fa-shield',
      create: 'fa-plus-square-o',
      download: 'fa-download',
      'database-backup': 'fa-database',
      review: 'fa-check-square-o',
      execute: 'fa-caret-square-o-right',
      summaryReport: 'fa-file',
      individualReport: 'fa-file-pdf-o',
    };
    return map[iconName] || 'fa-circle';
  }

  private buildMenuGroups(): void {
    const candidates: Array<RoleMenuGroup & { show?: boolean }> = [
      { key: 'master', label: 'Master', menuList: this.masterMenu, show: true },
      { key: 'board', label: 'Board Evaluation', menuList: this.boardEvaluationMenu, prefix: 'board-', show: this.isBoardEvaluationConfig },
      { key: 'risk', label: 'Risk Evaluation', menuList: this.riskEvaluationMenu, prefix: 'risk-', show: this.isRiskEvaluationConfig },
      { key: 'compliance', label: 'Compliance', menuList: this.complianceMenu, show: this.isPSSConfig || this.isAllConfig },
      { key: 'upsi', label: 'UPSI', menuList: this.upsiMenu, show: this.isUPSIConfig },
      { key: 'ncd', label: 'NCD', menuList: this.ncdMenu, show: this.isNCDConfig },
      { key: 'admin', label: 'Admin', menuList: this.adminMenu, flat: true, show: true },
      { key: 'dashboard', label: 'Dashboard', menuList: this.dashboardMenu, flat: true, show: this.isGovevaConfig || this.isAllConfig || this.isPSSConfig },
      { key: 'gem', label: 'DigiCompany Boards', menuList: this.gemMenu, show: this.isGEMConfig },
      { key: 'laws', label: 'Laws & Regulations', menuList: this.lawAndRegulationMenu, show: this.isLawsConfig },
    ];

    this.menuGroups = candidates
      .filter(group => group.show && group.menuList && group.menuList.length > 0)
      .map(({ show, ...group }) => group);

    if (this.menuGroups.length && !this.menuGroups.some(group => group.key === this.activeMenuKey)) {
      this.activeMenuKey = this.menuGroups[0].key;
    }
  }

  onIconClick(
    event: MouseEvent,
    menuElement: any,
    menuDisplayName: string,
    childDetails: any,
    menuList: any[]
  ): void {
    event.stopPropagation();

    if (childDetails.IconName === 'view' && menuElement.ChildResources) {
      const hasOtherSelected = menuElement.ChildResources.some(
        (element: any) =>
          element.IconName !== 'view' && this.selectedUrls.has(element.Url)
      );
      if (hasOtherSelected) {
        return;
      }
    }

    if (!this.selectedUrls.has(childDetails.Url)) {
      this.selectedUrls.add(childDetails.Url);
      this.urlMenuKeyMap.set(childDetails.Url, menuDisplayName);

      const autoViewIcons =
        childDetails.IconName !== 'view' &&
        childDetails.IconName !== 'edit' &&
        childDetails.IconName !== 'sendToAssessee' &&
        childDetails.IconName !== 'status';

      if (autoViewIcons && menuElement.ChildResources) {
        menuElement.ChildResources
          .filter((element: any) => element.IconName === 'view' && !this.selectedUrls.has(element.Url))
          .forEach((element: any) => {
            this.selectedUrls.add(element.Url);
            this.urlMenuKeyMap.set(element.Url, menuDisplayName);
          });
      }
    } else {
      this.selectedUrls.delete(childDetails.Url);
      this.urlMenuKeyMap.delete(childDetails.Url);
    }

    this.syncSelectionState();
  }


  ngOnInit() {
    this.loaderService.disable();
    this.loggedInUserInfo = JSON.parse(localStorage.getItem("user")).TypeOfUser;
    if (this.loggedInUserInfo === PermissionLinks.GuestSuperAdmin) {
      this.isGuestSuperAdmin = true;
    } else {
      this.isGuestSuperAdmin = false;
    }

    this.checkboxClickSelected = false;
    this.roleMasterService.roleActivityCheckboxList()
      .then(response => {
        //console.log("response", response);
        if (response.status == 0) {
          let resources = response.Resources;
          var resourcesCache = response.Resources;

          if (!this.isGuestSuperAdmin) {
            _.remove(resources, function (resourceElement: any) { return resourceElement.MenuDisplayName == 'Roadmap' });
          }

          // if UPSI is not selected then Email templates should be inside Compaliance Menu
          if (this.isAllConfig) {
            _.remove(resources, function (resourceElement: any) {
              return ((resourceElement.ParentMenuName == roleMasterMenuname.UPSI) && (resourceElement.Menu == roleMasterMenuname.EmailTemplate))
            })
          } else {

            if (this.isPSSConfig && !(this.isGovevaConfig || this.isAllConfig || this.isUPSIConfig || this.isBoardEvaluationConfig)) {  //|| this.isBoardEvaluationConfig             

              _.remove(resources, function (resourceElement: any) { return (resourceElement.Menu == roleMasterMenuname.EmailTemplate) })
              _.remove(resources, function (resourceElement: any) { return ((resourceElement.ParentMenuName != roleMasterMenuname.Master) && (resourceElement.ParentMenuName != roleMasterMenuname.Compliance) && (resourceElement.ParentMenuName != roleMasterMenuname.DocumentManagement) && (resourceElement.ParentMenuName != roleMasterMenuname.LawsAndRegulations) && (resourceElement.ParentMenuName != roleMasterMenuname.UPSI)) });
            }

            if (this.isGovevaConfig && !(this.isPSSConfig || this.isAllConfig || this.isUPSIConfig || this.isBoardEvaluationConfig)) { //|| this.isBoardEvaluationConfig
              // console.log("resources - isGovevaConfig")
              _.remove(resources, function (resourceElement: any) { return ((resourceElement.ParentMenuName == roleMasterMenuname.Compliance) || (resourceElement.ParentMenuName == roleMasterMenuname.DocumentManagement) || (resourceElement.ParentMenuName == roleMasterMenuname.UPSI)) });
            }

            if (this.isBoardEvaluationConfig && !(this.isGovevaConfig || this.isPSSConfig || this.isAllConfig || this.isUPSIConfig)) { //this.isBoardEvaluationConfig && 
              console.log("resources - Board Evaluation")
              _.remove(resources, function (resourceElement: any) { return ((resourceElement.ParentMenuName != roleMasterMenuname.BoardEvaluation) && (resourceElement.ParentMenuName != roleMasterMenuname.Master)) });
            }

            if (this.isPSSConfig && !(this.isGovevaConfig || this.isAllConfig || this.isUPSIConfig || this.isRiskEvaluationConfig)) {  //|| this.isRiskEvaluationConfig             

              _.remove(resources, function (resourceElement: any) { return (resourceElement.Menu == roleMasterMenuname.EmailTemplate) })
              _.remove(resources, function (resourceElement: any) { return ((resourceElement.ParentMenuName != roleMasterMenuname.Master) && (resourceElement.ParentMenuName != roleMasterMenuname.Compliance) && (resourceElement.ParentMenuName != roleMasterMenuname.DocumentManagement) && (resourceElement.ParentMenuName != roleMasterMenuname.LawsAndRegulations) && (resourceElement.ParentMenuName != roleMasterMenuname.UPSI)) });
            }

            if (this.isGovevaConfig && !(this.isPSSConfig || this.isAllConfig || this.isUPSIConfig || this.isRiskEvaluationConfig)) { //|| this.isRiskEvaluationConfig
              // console.log("resources - isGovevaConfig")
              _.remove(resources, function (resourceElement: any) { return ((resourceElement.ParentMenuName == roleMasterMenuname.Compliance) || (resourceElement.ParentMenuName == roleMasterMenuname.DocumentManagement) || (resourceElement.ParentMenuName == roleMasterMenuname.UPSI)) });
            }

            if (this.isRiskEvaluationConfig && !(this.isGovevaConfig || this.isPSSConfig || this.isAllConfig || this.isUPSIConfig)) { //this.isRiskEvaluationConfig && 
              console.log("resources - Risk Evaluation")
              _.remove(resources, function (resourceElement: any) { return ((resourceElement.ParentMenuName != roleMasterMenuname.RiskEvaluation) && (resourceElement.ParentMenuName != roleMasterMenuname.Master)) });
            }

            if (this.isUPSIConfig && !(this.isGovevaConfig || this.isPSSConfig || this.isAllConfig || this.isRiskEvaluationConfig)) { //|| this.isRiskEvaluationConfig
              // console.log("resources - UPSI")
              _.remove(resources, function (resourceElement: any) { return !((resourceElement.ParentMenuName == roleMasterMenuname.Master) || (resourceElement.ParentMenuName == roleMasterMenuname.UPSI)) });

              _.remove(resources, function (resourceElement: any) {
                return ((resourceElement.ParentMenuName == roleMasterMenuname.Master) && !((resourceElement.Menu == roleMasterMenuname.RoleMenu) || (resourceElement.Menu == roleMasterMenuname.UserMenu) || (resourceElement.Menu == roleMasterMenuname.CompanyMenu) || (resourceElement.Menu == roleMasterMenuname.UPSIMaster) || (resourceElement.Menu == roleMasterMenuname.UPSIParameter)))
              })

              // console.log("resources - UPSI")
            }

            if (this.isUPSIConfig && !(this.isGovevaConfig || this.isPSSConfig || this.isAllConfig || this.isBoardEvaluationConfig)) { //|| this.isBoardEvaluationConfig
              // console.log("resources - UPSI")
              _.remove(resources, function (resourceElement: any) { return !((resourceElement.ParentMenuName == roleMasterMenuname.Master) || (resourceElement.ParentMenuName == roleMasterMenuname.UPSI)) });

              _.remove(resources, function (resourceElement: any) {
                return ((resourceElement.ParentMenuName == roleMasterMenuname.Master) && !((resourceElement.Menu == roleMasterMenuname.RoleMenu) || (resourceElement.Menu == roleMasterMenuname.UserMenu) || (resourceElement.Menu == roleMasterMenuname.CompanyMenu) || (resourceElement.Menu == roleMasterMenuname.UPSIMaster) || (resourceElement.Menu == roleMasterMenuname.UPSIParameter)))
              })

              // console.log("resources - UPSI")
            }

            if ((this.isUPSIConfig && this.isPSSConfig) && !this.isBoardEvaluationConfig) { //&& !this.isBoardEvaluationConfig
              // _.remove(resources, function (resourceElement: any) { return ((resourceElement.Menu == roleMasterMenuname.EmailTemplate)|| (resourceElement.ParentMenuName == roleMasterMenuname.GEM) ) } )
              _.remove(resources, function (resourceElement: any) { return (resourceElement.Menu == roleMasterMenuname.EmailTemplate) })

            }

            if ((this.isUPSIConfig && this.isPSSConfig) && !this.isRiskEvaluationConfig) { //&& !this.isRiskEvaluationConfig
              // _.remove(resources, function (resourceElement: any) { return ((resourceElement.Menu == roleMasterMenuname.EmailTemplate)|| (resourceElement.ParentMenuName == roleMasterMenuname.GEM) ) } )
              _.remove(resources, function (resourceElement: any) { return (resourceElement.Menu == roleMasterMenuname.EmailTemplate) })

            }

          }

          // _.remove(resources, function (resourceElement: any) { return resourceElement.MenuDisplayName == 'Roadmap' });

          if (_.size(resources)) {

            resources.forEach(resource => {
              switch (resource.ParentMenuName) {
                case roleMasterMenuname.Master:
                  this.masterMenu.push(resource);
                  break;
                case roleMasterMenuname.BoardEvaluation:
                  this.boardEvaluationMenu.push(resource);
                  break;
                case roleMasterMenuname.RiskEvaluation:
                  this.riskEvaluationMenu.push(resource);
                  break;
                case roleMasterMenuname.Governance:
                  if (resource.MenuDisplayName == "Assessment") {
                    if (this.isGuestSuperAdmin) {
                      _.remove(resource.ChildResources, function (childElement: any) { return (childElement.DisplayName == 'Execute' || childElement.DisplayName == 'Review') });
                    } else {
                      _.remove(resource.ChildResources, function (childElement: any) { return (childElement.DisplayName == 'IC Execute' || childElement.DisplayName == 'IC Review' || childElement.DisplayName == 'View Only' || childElement.DisplayName == 'Edit') });
                    }
                  }
                  this.governanceMenu.push(resource);
                  break;
                case roleMasterMenuname.Compliance:
                  this.complianceMenu.push(resource);
                  break;
                case roleMasterMenuname.UPSI:
                  this.upsiMenu.push(resource);
                  //console.log("this.uose menu", this.upsiMenu);
                  break;
                case roleMasterMenuname.DocumentManagement:
                  this.documentManagementMenu.push(resource);
                  break;
                case roleMasterMenuname.Admin:
                  // this.adminMenu.push(resource);
                  this.adminMenu = resource.ChildResources;
                  break;
                case roleMasterMenuname.Dashboard:
                  //console.log("resource",resource)                       
                  this.dashboardMenu = resource.ChildResources;
                  break;
                case roleMasterMenuname.GEM:
                  // console.log("resource", resource)
                  this.gemMenu.push(resource);

                  break;
                case roleMasterMenuname.LawsAndRegulations:

                  this.lawAndRegulationMenu.push(resource);
                  //console.log("this.lawAndRegulationMenu", this.lawAndRegulationMenu[0].MenuDisplayName)
                  break;
                case roleMasterMenuname.NCD:
                  this.ncdMenu.push(resource);
                  break;
              }


            });

            //console.log("this.gemMenu", this.gemMenu)

          }

          this.buildMenuGroups();
          this.cdr.detectChanges();

        } else {
          //console.log("error getting resources list")
        }

      })

  }

  cancel() {
    this.activeModal.dismiss('dismissed')
  }


  removeAddedRoleList(index, addedRole) {
    const urlsToRemove = this.finalRoleList
      .filter((role: any) => role.MenuDisplayName === addedRole.MenuDisplayName)
      .map((role: any) => role.childUrl);
    this.deselectUrls(urlsToRemove);
  }

  SubmitRole() {
    let inputRoleName = this.addRoleForm.get('roleName').value.trim();

    let finalRoleActivities = [];
    this.finalRoleList.forEach(roleList => {
      finalRoleActivities.push(roleList.childUrl);
    });
    //console.log("inputRoleName-finalRoleActivities", inputRoleName, finalRoleActivities);

    this.roleMasterService.addNewRole(inputRoleName, finalRoleActivities)
      .then(response => {
        if (response.status == 0) {
          //console.log("successfully added role");
          this.activeModal.close(response);
        } else {
          //console.log("role not added");
          this.activeModal.close(response);
        }
      }, error => { }
        // console.log("")
      )
  }

  CancelModal() {
    this.activeModal.dismiss('dismissed');
  }

  // Helper function to strip prefix for display purposes
  getDisplayName(menuDisplayName: string): string {
    if (menuDisplayName.startsWith('board-')) {
      return menuDisplayName.substring(6); // Remove 'board-' prefix
    } else if (menuDisplayName.startsWith('risk-')) {
      return menuDisplayName.substring(5); // Remove 'risk-' prefix
    }
    return menuDisplayName;
  }

}
